import { render, staticRenderFns } from "./payments-amount.vue?vue&type=template&id=3e27f4cc&"
import script from "./payments-amount.vue?vue&type=script&lang=js&"
export * from "./payments-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports